var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmOutlineSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.625 .938)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E24545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M0 13.063L6.859 0 13.719 13.063zM6.86 5.5v2.75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.859,
    cy: 10.313,
    r: 1,
    fill: "#E24545",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmOutlineSmall);
export default __webpack_public_path__ + "static/media/alarm-outline-small.26ad66d32a624a7583e57d9e9531788d.svg";
export { ForwardRef as ReactComponent };